/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import propTypes from 'prop-types';
import './index.scss';

export default function FileSelect({ id, ...props }) {
  return (
    <div className="file-select-container border-primary">
      <label htmlFor={id} className="text-primary">
        Adicionar arquivo(s)
      </label>
      <input type="file" id={id} {...props} />
    </div>
  );
}

FileSelect.propTypes = {
  id: propTypes.string.isRequired,
};
